import { Menu } from 'lucide-react';
import { useEffect, useState } from 'react';
import { NAV_LINKS, IMAGES } from '../mock';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
    // setScrolled is stable from useState; onScroll is scoped inside effect
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[#0d281e]/95 backdrop-blur-sm shadow-lg py-2 border-b border-[#b39352]/25'
          : 'bg-transparent py-3'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between">
        {/* Logo */}
        <a href="#top" className="flex items-center">
          <img
            src={IMAGES.logo}
            alt="Valley Mills · Pudsey · Leeds"
            className={`transition-all duration-300 ${scrolled ? 'h-14' : 'h-16'} w-auto`}
          />
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-[13px] text-[#f1ede5] hover:text-[#b39352] transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-6">
          <a
            href="tel:01138474474"
            className="hidden md:inline text-[13px] text-[#f1ede5] hover:text-[#b39352] transition-colors"
          >
            0113 847 4474
          </a>
          <a href="#enquire" className="btn-gold !py-3 !px-5 !text-[10px]">
            Enquire
          </a>
          <button
            className="lg:hidden text-[#f1ede5]"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            <Menu size={22} />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0d281e] border-t border-[#b39352]/20 mt-3">
          <div className="px-6 py-4 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="text-[13px] text-[#f1ede5]">
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
